import HttpRequest from './HttpRequest';

export default class cancellationReasonsService extends HttpRequest {
  static endpoint = 'cancellation-reasons';

  static async getAll() {
    this.endpoint = 'cancellation-reasons';
    const response = await this.get();
    return response;
  }

  static async getById(id) {
    this.endpoint = 'cancellation-reasons';
    const response = await this.get(id);
    return response;
  }

  static async create(data) {
    this.endpoint = 'cancellation-reasons';
    const response = await this.post(data);
    return response;
  }

  static async remove(id) {
    this.endpoint = 'cancellation-reasons';
    const response = await this.delete(id);
    return response;
  }

  static async update(id, data) {
    this.endpoint = 'cancellation-reasons';
    const response = await this.put(id, data);
    return response;
  }
}
